import events from '../events';
import { imageZoom } from '../utils/image-zoom';
import { lazyLoader } from '../utils/lazy-loader';
import { pushObjectToState } from "../utils/push-state";
const DefaultSortOrder = 1;
const SearchSortOrder = 0;
export function productList(data, viewType) {
    var _a, _b;
    return {
        id: data.id,
        name: data.name,
        title: data.title,
        description: data.description,
        products: [],
        productCount: 0,
        campaignId: data.campaignId,
        sortOrders: data.sortOrders,
        typeOfProducts: data.typeOfProducts,
        filterCategories: data.filterCategories,
        searchQuery: data.searchQuery || '',
        chosenFilterItems: [],
        _currentSortOrder: data.defaultSortOrder,
        _currentProductType: data.defaultProductType === null && data.typeOfProducts === null
            ? null
            : ((_a = data.defaultProductType) !== null && _a !== void 0 ? _a : 0),
        filterCategoriesIds: (_b = data.defaultFilterIds) !== null && _b !== void 0 ? _b : [],
        get allFilterItems() {
            return this.filterCategories.flatMap((item) => {
                if (!item.children) {
                    return [item];
                }
                return [
                    item,
                    ...item.children,
                    ...item.children.flatMap(c => { var _a; return (_a = c.children) !== null && _a !== void 0 ? _a : []; })
                ];
            });
        },
        showFilterCategories: false,
        isPopState: false,
        nextPage: undefined,
        isLoading: false,
        // indicates if user was scrolled to remembered position
        scrolledToProduct: false,
        // stores remembered id, to scroll user to that position 
        idPosition: '',
        // stores remembered offset (from previous browsing), to scroll user to that position 
        offsetPosition: 0,
        lazyLoader: lazyLoader(),
        viewHandler: productListingViewHandler(viewType),
        imageZoom: imageZoom(),
        $refs: {},
        init() {
            this.triggerFilter().then(() => {
                this.lazyLoader.fetchRequest = () => {
                    var _a;
                    var filterObject = {
                        offset: this.lazyLoader.offset,
                        limit: this.lazyLoader.limit,
                        q: this.searchQuery,
                    };
                    filterObject.sortOrder = this.currentSortOrder;
                    if (((_a = this.filterCategoriesIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        filterObject.filterCategoriesIds = this.filterCategoriesIds;
                    }
                    if (this.currentProductType != null) {
                        filterObject.type = this.currentProductType;
                    }
                    if (this.nextPage) {
                        filterObject.nextPage = this.nextPage;
                    }
                    this.triggerFilter(filterObject, false);
                };
                this.scrollToRememberedIdPosition();
                setTimeout(() => this.lazyLoader.lazyInit(this.$refs['scrollTarget']), 100);
            });
            events.onPopState.subscribe(state => {
                this.currentSortOrder = parseInt(state.sortOrder);
                this.searchQuery = "";
                this.isPopState = true;
                this.filterCategoriesIds = state.filterCategoriesIds;
            });
            if (this.filterCategoriesIds.length > 0) {
                this.onFilterCategoryChanged(this.filterCategoriesIds);
            }
            this.chosenFilterItems = this.allFilterItems
                .filter(itm => this.filterCategoriesIds.indexOf(itm.id) > -1);
        },
        apiSearch(filterData, abort) {
            return new Promise(r => r({
                items: [],
                total: 0,
            }));
        },
        isChecked(itemId) {
            return this.filterCategoriesIds.includes(itemId);
        },
        async addOrRemoveFilter(item) {
            var _a;
            this.lazyLoader.offset = 0;
            this.productCount = 0;
            this.lazyLoader.page = 1;
            this.products = [];
            if (item) {
                if (this.filterCategoriesIds.includes(item.id)) {
                    this.removeFilter(item);
                }
                else {
                    this.filterCategoriesIds = [...new Set(this.filterCategoriesIds), item.id];
                }
                this.filterCategoriesIds.filter((v, i, a) => a.indexOf(v) === i);
                this.chosenFilterItems = this.allFilterItems.filter(itm => this.filterCategoriesIds.includes(itm.id));
            }
            else {
                this.filterCategoriesIds = [];
                this.chosenFilterItems = [];
            }
            this.onFilterCategoryChanged(this.filterCategoriesIds);
            let searchObject = {
                offset: this.lazyLoader.offset,
                limit: this.lazyLoader.limit,
                q: this.searchQuery,
            };
            searchObject.sortOrder = this.currentSortOrder;
            if (((_a = this.filterCategoriesIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                searchObject.filterCategoriesIds = this.filterCategoriesIds;
            }
            if (this.currentProductType != null) {
                searchObject.type = this.currentProductType;
            }
            await this.triggerFilter(searchObject, true);
        },
        removeFilter(item) {
            if (item) {
                let newFilterCategoriesIds = this.filterCategoriesIds.filter(id => {
                    var _a;
                    if (item.id === id) {
                        return false;
                    }
                    return !((_a = item.children) === null || _a === void 0 ? void 0 : _a.some(child => child.id === id));
                });
                this.filterCategoriesIds = newFilterCategoriesIds;
            }
            else {
                this.filterCategoriesIds = [];
            }
        },
        showFilterBtnText() {
            if (this.filterCategoriesIds.length === 0) {
                return '';
            }
            return ` (${this.filterCategoriesIds.length})`;
        },
        get currentSortOrder() {
            return this._currentSortOrder;
        },
        set currentSortOrder(sortOrder) {
            if (this._currentSortOrder === sortOrder) {
                return;
            }
            this._currentSortOrder = sortOrder;
        },
        get currentProductType() {
            return this._currentProductType;
        },
        set currentProductType(productType) {
            if (this._currentProductType === productType) {
                return;
            }
            this._currentProductType = productType;
        },
        search() {
            this.lazyLoader.limit = 10;
            this.lazyLoader.offset = 0;
            this.triggerFilter();
        },
        _activeFetch: undefined,
        async getProducts(filterData, shouldEmptyList) {
            var _a;
            this.lazyLoader.isLazyLoading = true;
            this.isLoading = true;
            try {
                const shouldFetch = shouldEmptyList ? true : this.productCount > this.products.length;
                if (shouldFetch) {
                    const abortController = new AbortController();
                    (_a = this._activeFetch) === null || _a === void 0 ? void 0 : _a.abort();
                    this._activeFetch = abortController;
                    const searchResult = await this.apiSearch(filterData, abortController.signal);
                    if (shouldEmptyList) {
                        this.products = searchResult.items;
                    }
                    else {
                        searchResult.items.forEach(product => this.products.push(product));
                    }
                    this.productCount = searchResult.total;
                    this.nextPage = searchResult.nextPage;
                    if (this.products.length == 0) {
                        this.lazyLoader.page -= 1;
                        this.lazyLoader.offset += this.lazyLoader.limit;
                    }
                }
            }
            catch (e) {
                // if we aborted the fetch then we do nothing
                if (e.name !== 'AbortError')
                    throw e;
            }
            finally {
                this.lazyLoader.isLazyLoading = false;
                this.isLoading = false;
            }
        },
        triggerFilter(details, shouldEmptyList = true) {
            var _a, _b;
            this.readOffsetAndIdPosition();
            var filterObject = details === undefined ? {
                offset: this.lazyLoader.offset,
                limit: this.lazyLoader.limit,
                q: this.searchQuery,
            } : { ...details };
            filterObject.sortOrder = this.currentSortOrder;
            if (((_a = this.filterCategoriesIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                filterObject.filterCategoriesIds = this.filterCategoriesIds;
            }
            if (this.currentProductType != null) {
                filterObject.type = this.currentProductType;
            }
            if (this.id) {
                filterObject.categoryId = this.id;
            }
            if (this.campaignId) {
                filterObject.campaignId = this.campaignId;
            }
            if (shouldEmptyList) {
                const filterCategoriesIds = filterObject.filterCategoriesIds != null ? [...filterObject.filterCategoriesIds] : [];
                const objectToSave = (_b = window.history.state) !== null && _b !== void 0 ? _b : {};
                const defaultSortOrder = this.searchQuery ? SearchSortOrder : DefaultSortOrder;
                if (filterObject.q) {
                    objectToSave.q = filterObject.q;
                }
                if (filterObject.sortOrder !== defaultSortOrder) {
                    objectToSave.sortOrder = filterObject.sortOrder;
                }
                if (filterCategoriesIds.length > 0) {
                    objectToSave.filterCategoriesIds = filterCategoriesIds;
                }
                if (this.currentProductType != null) {
                    objectToSave.type = this.currentProductType;
                }
                if (!this.isPopState && Object.keys(objectToSave).length > 0) {
                    pushObjectToState(objectToSave);
                }
                this.isPopState = false;
            }
            this.saveToRequestOffsetAndIdPosition(filterObject);
            return this.getProducts(filterObject, shouldEmptyList);
        },
        onFilterCategoryChanged(ids) { },
        saveSearch() {
            if (!document.body.dataset.username) {
                events.openLogin.trigger({ open: true });
                return;
            }
            const ids = this.products.slice(0, 10).map(p => p.sku);
            events.onShowSaveSearch.trigger({
                resultIds: ids,
                source: "WebShop",
            });
        },
        // SCROLL TO ITEM FUNCTIONS
        // Scroll page to remembered id from the state and clear state
        scrollToRememberedIdPosition() {
            if (!this.scrolledToProduct && this.idPosition) {
                setTimeout(() => {
                    // scroll page
                    let element = document.getElementById(this.idPosition);
                    let top = element ? element.offsetTop : 0;
                    window.scroll({ top: top, left: 0, behavior: 'smooth' });
                    // remove remembered item
                    this.scrolledToProduct = true;
                    this.offsetPosition = 0;
                    this.idPosition = '';
                    if (window.history.state != null) {
                        let currentState = window.history.state;
                        delete currentState["idPos"];
                        delete currentState["offPos"];
                        pushObjectToState(currentState);
                    }
                }, 500);
            }
        },
        // Save to state clicked item and current offset
        rememberClickedId(id) {
            let webPageState = window.history.state;
            if (webPageState == null) {
                pushObjectToState({ "idPos": id, "offPos": this.lazyLoader.offset });
            }
            else {
                webPageState.idPos = id;
                webPageState.offPos = this.lazyLoader.offset;
                pushObjectToState(webPageState);
            }
        },
        // Read if id position and offset position are present in the state
        readOffsetAndIdPosition() {
            if (window.history.state != null && !this.scrolledToProduct) {
                this.idPosition = window.history.state.idPos;
                this.offsetPosition = window.history.state.offPos;
                // interfere in lazy loader offsetting mechanism - we need to get all 
                // entries if we load whole page
                if (this.offsetPosition > 0) {
                    this.lazyLoader.offset = this.offsetPosition;
                }
            }
        },
        // Update query filter object with position items
        saveToRequestOffsetAndIdPosition(filterObject) {
            // if remembered position exists, add to filters those values
            if (this.idPosition) {
                filterObject.idPos = this.idPosition;
                filterObject.offPos = this.offsetPosition;
            }
        },
    };
}
export function productListingViewHandler(viewType) {
    return {
        viewType: viewType || (localStorage['productListView'] || 'list'),
        toggleView(type) {
            if (type === this.viewType && this.viewType === 'list') {
                this.viewType = 'grid';
                localStorage['productListView'] = this.viewType;
            }
            else if (type === this.viewType && this.viewType === 'grid') {
                this.viewType = 'list';
                localStorage['productListView'] = this.viewType;
            }
        },
        toggleButtonStyle(type) {
            if (type === 'list' && this.viewType === 'grid') {
                return 'noHover';
            }
            else if (type === 'grid' && this.viewType === 'list') {
                return 'noHover';
            }
            return 'button-ghost';
        },
    };
}
